import { EmptyView, emptyViewVariants } from '@components'

import { ReactElement } from 'react'

import * as Styled from './styles'

export const BlockedEInvoiceEmptyState = (): ReactElement => {
  const { description, illustration, title } = emptyViewVariants.einvoicesBlocked

  return (
    <Styled.BlockedEInvoiceEmptyStateWrapper>
      <EmptyView illustration={illustration} tDescription={description} tTitle={title} />
    </Styled.BlockedEInvoiceEmptyStateWrapper>
  )
}
